<script lang="ts">
	import { Button, Text, Input } from '@Shelly/shelly-design-system';
	import {
		control_bluetooth_device_ios,
		control_bluetooth_general_ios,
	} from 'src/services/native_container_requests_ios';
	import {
		control_bluetooth_device_android,
		control_bluetooth_general_android,
	} from 'src/services/native_container_requests_android';

	import { app, os } from 'src/stores/session/native-bridge';
	import { controlBleDevice } from 'src/stores/features/ble/control-device';
	import { bulkUpdate } from '../ApplicationSettings/app_settings_helper';
	import { format } from 'svelte-i18n';
	import { valueOutOfRange } from 'src/helpers/utilities';
	import { BLU_STATUS } from 'src/types/requests/settings/blu_status';

	export let device;

	const min = 0;
	const max = 1000000;
	const command = 'setFireGroup';
	const param = 'fireGroup';

	let fireGroup: any = device?.fireGroup || min;
	let initialized = false;

	const onSave = () => {
		if ($controlBleDevice.connectionState === 2) {
			if ($os === 'IOS') {
				control_bluetooth_general_ios(device.id, command, param, fireGroup);
			} else {
				control_bluetooth_general_android(device.id, command, param, fireGroup);
			}

			bulkUpdate(device.id, { fireGroup });
		} else {
			if ($os === 'IOS') {
				control_bluetooth_device_ios(device.id, 'connect');
			} else {
				control_bluetooth_device_android(device.id, 'connect');
			}
		}
	};

	const UNINITIALIZED_STATUSES = new Set([
		BLU_STATUS.UNHANDLED_STATE,
		BLU_STATUS.BUTTON_PRESS_REQUIRED,
		BLU_STATUS.CONNECT_TO_DEVICE,
		BLU_STATUS.DISCONNECT_FROM_DEVICE,
	]);

	const INITIALIZED_STATUSES = new Set([
		BLU_STATUS.DEVICE_PROCESSED,
		BLU_STATUS.BEACON_ENABLED,
		BLU_STATUS.BEACON_DISABLED,
		BLU_STATUS.MIN_ANGLE_THRESHOLD_SET,
	]);

	$: {
		const status = $controlBleDevice.currentStatusIndex;
		if (UNINITIALIZED_STATUSES.has(status)) {
			initialized = false;
		} else if (INITIALIZED_STATUSES.has(status)) {
			initialized = true;
		}
	}

	$: error = valueOutOfRange(fireGroup, min, max)
		? $format('error_out_of_range', {
				default: `Value ${fireGroup} is out of range. Please provide a value within the limits. (${min} — ${max})!`,
				values: { value: fireGroup, max, min, unit: '°' },
			})
		: '';
</script>

<Text class="mb-s ml-s" element="p" styleType="body-small">
	{$format('text_blu_setting_fire_group', {
		default: 'Set a fire group.',
	})}
</Text>

<Input
	id="input-i9c9nc2"
	aria-label={$format('input_blu_setting_fire_group', {
		default: `Enter the fire group. Value must be between ${min} — ${max}!`,
		values: { min, max },
	})}
	icon="fas fa-calculator"
	class="mb-m"
	bind:value={fireGroup}
	type="number"
	step={1}
	{min}
	{max}
	info={$format('movement_limit_toast', {
		default: `Values must be between ${min} — ${max}!`,
		values: { min, max },
	})}
	{error}
/>

<Button disabled={!initialized || !$app || error} size="m" width="full" on:click={onSave}>
	{$format('button_save', { default: 'Save' })}
</Button>
